// extracted by mini-css-extract-plugin
export var collapsedSummary = "_id-0";